import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { CommonUtilityService } from '../../services/common-utility.service';

@Component({
  selector: 'app-logout',
  template: '',
  styles: [],
  standalone: false,
})
export class LogoutComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  pageLabels: any;
  constructor(
    private readonly router: ActivatedRoute,
    private readonly commonUtilityService: CommonUtilityService,
  ) {
    this.pageLabels = this.commonUtilityService.getResolvedPageData();
  }

  ngOnInit(): void {
    /**
     * logout - to logout from the application and redirect to login
     */
    this.router.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        if (params.hasOwnProperty('signoff') && params.signoff === 'true') {
          this.commonUtilityService.getLogout(this.pageLabels);
        }
      });
  }
}
